// /api/public/auth/* — the only anonymous subset of the public chart API.
// Plain fetch, no Authorization header (these routes don't need or accept one).
const AUTH_BASE = (import.meta.env.VITE_API_BASE || '/api/public') + '/auth'

async function post(path, body) {
  const res = await fetch(AUTH_BASE + path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
  let data = null
  try { data = await res.json() } catch { /* no body */ }
  if (!res.ok) {
    const err = new Error(data?.detail || `Request failed: ${res.status}`)
    err.status = res.status
    err.body = data
    throw err
  }
  return data
}

export function me(bearerToken) {
  return fetch(AUTH_BASE + '/me', {
    headers: { Authorization: `Bearer ${bearerToken}` },
  }).then(async (res) => {
    const data = await res.json().catch(() => null)
    if (!res.ok) {
      const err = new Error(data?.detail || `Request failed: ${res.status}`)
      err.status = res.status
      throw err
    }
    return data
  })
}

// /api/public/auth/2fa/* — setup y verify aceptan tanto un chart_access
// token normal (reactivación tras un reset de recuperación) como un token
// de enrollment forzado (2FA obligatorio para todo chart_user) — el caller
// decide cuál pasar en `token`.
async function postAuthed(path, body, token) {
  const res = await fetch(AUTH_BASE + '/2fa' + path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(body),
  })
  let data = null
  try { data = await res.json() } catch { /* no body */ }
  if (!res.ok) {
    const err = new Error(data?.detail || `Request failed: ${res.status}`)
    err.status = res.status
    err.body = data
    throw err
  }
  return data
}

export function login(username, password) {
  return post('/login', { username, password })
}

export function requestAccess(email, username, website = '') {
  return post('/request-access', { email, username, website })
}

export function forgotPassword(email) {
  return post('/forgot-password', { email })
}

export function resetPassword(token, password) {
  return post('/reset-password', { token, password })
}

// ─── 2FA ───────────────────────────────────────────────────────────────

export function login2fa(tempToken, totpCode) {
  return post('/2fa/login', { temp_token: tempToken, totp_code: totpCode })
}

export function setup2fa(bearerToken, currentPassword) {
  return postAuthed('/setup', { current_password: currentPassword }, bearerToken)
}

export function verify2fa(bearerToken, currentPassword, totpCode) {
  return postAuthed('/verify', { current_password: currentPassword, totp_code: totpCode }, bearerToken)
}

// No hay disable2fa: el 2FA es obligatorio y /2fa/disable siempre rechaza
// (ver backend/app/api/routes/public/chart_2fa.py).
